import { Injectable } from "@angular/core"
import { environment } from "../../environments/environment"
import { Environment } from "../models/env"

@Injectable({
	providedIn: "root"
})
export class EnvService {
	private config?: Environment | null

	get domain(): string {
		return this.appConfig.domain
	}

	get urlApi(): string {
		return `${this.domain}/api/v1`
	}

	get appConfig(): Environment {
		return this.config || environment
	}

	get envName(): string {
		return this.appConfig.name
	}

	get isEnvLocal() {
		return this.envName === "local"
	}

	get isEnvStaging() {
		return this.envName === "staging"
	}

	get isEnvQuality() {
		return this.envName === "quality"
	}

	get isEnvProduction() {
		return this.envName === "production"
	}

	get realEstateRoleGroup(): string | null {
		return this.appConfig.realEstateRoleGroup
	}

	public loadConfigSync(): Environment | null | undefined {
		const xhr = new XMLHttpRequest()
		xhr.open("GET", "./assets/config/config.json", false) // false = sincrono
		try {
			xhr.send(null)
			if (xhr.status === 200) {
				this.config = JSON.parse(xhr.responseText)
				return this.config
			} else {
				console.warn("Errore nel caricamento configurazione a runtime [assets/config/config.json]:", xhr.status)
				return null
			}
		} catch (e) {
			console.warn("Errore nel caricamento configurazione a runtime [assets/config/config.json]:", e)
			return null
		}
	}
}
